import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { cannotPurchaseAgain } from "@circle-react/helpers/paywallCheckoutHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useEffect, useRef } from "react";

import { getAlreadyPurchasedMessage } from "@/react/components/Paywalls/Checkout/helpers";

interface AlertsProps {
  className?: string;
  shouldFocus?: boolean;
}

export const Alerts = ({ className, shouldFocus }: AlertsProps) => {
  const {
    paywall,
    communityRootUrl,
    hasAlreadyPurchased,
    paymentError,
    paywallFailure,
    isPerformingVerification,
  } = usePaywallCheckoutContext();

  const divRef = useRef<HTMLDivElement>(null);

  let level = "";
  let message = "";

  if (cannotPurchaseAgain(hasAlreadyPurchased, paywall)) {
    level = "warning";
    message = getAlreadyPurchasedMessage(communityRootUrl);
  } else if (paywallFailure) {
    level = paywallFailure.level;
    message = paywallFailure.message;
  } else if (paymentError && paymentError.message) {
    level = paymentError.type;
    message = paymentError.message;
  }

  useEffect(() => {
    if (shouldFocus && divRef && message) {
      divRef.current?.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [message, shouldFocus]);

  if (isPerformingVerification || !level || !message) {
    return null;
  }

  return (
    <div
      ref={divRef}
      className={classNames("rounded-lg border px-6 py-5", className, {
        "border-red-500 bg-red-50 text-red-800": level === "danger",
        "border-yellow-500 bg-yellow-50 text-yellow-800": level === "warning",
      })}
      dangerouslySetInnerHTML={{
        __html: message,
      }}
      data-testid="checkout-alert"
    />
  );
};
